function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { declMod, bool2string } from '@yandex-lego/i-bem-react';
import "./../__clear/textarea__clear.react.js";
import _textarea__clear_theme_normal from "./../__clear/_theme/textarea__clear_theme_normal.react.js";

var TextAreaClear = _textarea__clear_theme_normal.applyDecls();

import "./../__clear/textarea__clear.css";
export default declMod(function (props) {
  return props.hasClear && !(props.controlAttrs && props.controlAttrs.readOnly);
}, {
  block: 'textarea',
  mods: function mods(_ref) {
    var hasClear = _ref.hasClear;
    return _objectSpread({}, this.__base.apply(this, arguments), {
      'has-clear': bool2string(hasClear)
    });
  },
  content: function content(_ref2) {
    var visible = _ref2.text,
        theme = _ref2.theme,
        view = _ref2.view;
    var disabled = this.state.disabled;
    return [].concat(this.__base.apply(this, arguments), React.createElement(TextAreaClear, {
      onClick: this._onClearClick.bind(this),
      onMouseDown: this._preventLosingFocus.bind(this),
      key: 'clear',
      disabled: disabled,
      visible: visible,
      theme: theme,
      view: view
    }));
  },
  _preventLosingFocus: function _preventLosingFocus(e) {
    if (this.state.focused) {
      e.preventDefault();
    }
  },
  _onClearClick: function _onClearClick(e) {
    this._control.focus();

    this.setState({
      focused: true
    });
    this.props.onClearClick && this.props.onClearClick(e);

    if (!e.isDefaultPrevented()) {
      this.props.onChange('', this.props, {
        source: 'clear'
      });
    }
  }
}, {
  propTypes: {
    hasClear: PropTypes.bool
  }
});